<button id="help-button33" class="btn boton-ayuda mobile-fixe" data-bs-toggle="modal" data-bs-target="#helpModal">
  <img src="./assets/images/ayuda2.png" width="100%">
</button>

<!-- Modal de Ayuda -->
<div class="modal fade" id="helpModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header modal-pepsico-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Ayuda</h1>
        <button class="btn-close color-white" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body text-center">
        <p>Selecciona un canal para ponerte en contacto y podamos ayudarte.</p>

        <div class="row">
          <div class="col-sm-4">
            <img src="" alt="" class="channel">
            <button class="btn perfilbtn-pep w-100 mx-0" routerLink="/help" data-bs-dismiss="modal">Preguntas frecuentes</button>
          </div>
          <div class="col-sm-4">
            <img src="" alt="" class="channel">
            <button id="help-button-ayuda" class="btn perfilbtn-pep w-100 mx-0" (click)="openHelpBox2()" data-bs-dismiss="modal">Ayuda</button>
          </div>
          <div class="col-sm-4">
            <img src="" alt="" class="channel">
            <button class="btn perfilbtn-pep w-100 mx-0" routerLink="/my-orders/tickets" data-bs-dismiss="modal">Mis consultas</button>
          </div>
        </div>
      </div>
      <div class="modal-footer jf-center">
        <button type="button" class="btn btn-primary perfilbtn-pep mx-auto" data-bs-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>

<!-- Caja de Ayuda 2 -->
<div [hidden]="!showHelpBox2" id="help-box2" class="ayuda-contenedor ayuda-contenedor2" style="display: block; z-index: 9999; position: fixed; width: 280px; height: auto; max-height: 440px; bottom: 80px; right: 15px; border-radius: 15px;">
  <div class="box-header-ayuda" style="position: relative;">
    <button id="close-box2" class="btn close-box" (click)="closeHelpBox2()">X</button>
    <h2 class="m-0" style="font-size: 18px;">Ayuda</h2>
  </div>
  <div class="box-body" [hidden]="showThxBox2" style="padding: 12px; position: relative;">
    <select [(ngModel)]="helpData.duda" class="form-control form-control-sm" name="select" style="font-size: 13px; position: relative;">
      <option value="" selected="">Selecciona tu duda</option>
      <option *ngFor="let type of incidentTypes" [value]="type.idValue">{{type.textValue}}</option>
    </select>
    <textarea [(ngModel)]="helpData.comentarios" name="comentarios" placeholder="Comentarios" cols="30" rows="3" class="form-control w-100 mt-1" maxlength="1000" style="font-size: 13px; min-height: 80px; max-height: 80px;"></textarea>
    <span class="ter-color" style="font-size: 9px;">Hasta 1000 caracteres</span>
    <div class="input-container" style="margin-top: 8px; margin-bottom: 8px; background-color: #EDEDED; box-shadow: 0px 2px 5px 0px rgba(194, 194, 194, 1); border-radius: 4px; text-align: right; display: flex; align-items: center;">
      <input type="file" class="file-help" id="real-input" (change)="onFileSelected($event)" accept="image/*" style="display: none;">
      <span class="file-info" style="font-size: 11px; flex: 1; padding-left: 10px; text-align: left;">{{fileName || 'Sin archivo'}}</span>
      <button type="button" class="browse-btn" (click)="triggerFileInput()" style="font-size: 11px; padding: 8px;">
        Adjuntar archivo
      </button>
    </div>

    <button id="send-help2" class="btn btn-primary perfilbtn-pep w-100 m-0" (click)="sendHelp2()" style="font-size: 13px; padding: 8px;">
      Enviar
    </button>
  </div>
  <div [hidden]="!showThxBox2" id="thx-box2" class="thx-box2" style="display: block;height: 440px;">
    <h2 style="font-size: 18px;">Gracias</h2>
    <p style="font-size: 13px;">TUS COMENTARIOS FUERON ENVIADOS EXITOSAMENTE</p>
    <span style="font-size: 12px;">Recibirás un mail y en breve un experto atenderá tu duda.</span>
    <button id="close-help-box2" class="btn btn-ouline" (click)="closeHelpBox2()" style="font-size: 13px;">
      Cerrar
    </button>
  </div>
</div>
